import React from 'react'
import { connect } from 'react-redux'
import { hasBadRepresentantScore, hasBadDenominationScore } from 'Utils/inpi-scores-checks'

import 'Ui/input.sass'
import '../../SubscriptionPage/steps/step.sass'
import '../AdressPage/editAddressModal.sass'
import { reverse } from 'lodash'

interface Props {
  currentUser: any
}

interface BlockProps {
  currentUser: any
}

const MailTo = () => <a className='[&&]:text-blue' href="mailto:contact@ma-domiciliation.fr">contact@ma-domiciliation.fr</a>

const formatNestedRepresentant = (is_nested_representant_of) => {
  if (!is_nested_representant_of) return ''
  const splitted = reverse(is_nested_representant_of.split(','))
  return ` (représentant de la société ${splitted.join(', elle-même représentante de la société ')})`
}

const formatInpiRepresentant = (representant) => {
  const firstnames = JSON.parse(representant.firstnames) || []

  const nested = formatNestedRepresentant(representant.is_nested_representant_of)

  return `${firstnames.join(', ')} ${representant.name}${nested}`
}

const WrongRepresentantBlock = ({ currentUser }: BlockProps) => {
  const { representant, inpiRepresentants } = currentUser
  return (
    <div className="mb-4">
      <div className="mb-3">
        Le représentant légal que vous avez déclaré ({representant.firstname} {representant.name}) n'apparaît pas sur le site de l’INPI, qui affiche le(s) représentant(s) suivant(s) :
      </div>
      <ul className='[&&]:list-[circle] ml-6'>
        {inpiRepresentants.filter(r => r.type_personne === 'INDIVIDU').map((r, index) => (
          <li key={index}>{formatInpiRepresentant(r)}</li>
        ))}
      </ul>
      <div className="mt-4">
        <div>- Si le représentant légal a été modifié, merci de renseigner les informations du nouveau représentant en cliquant <a className='[&&]:text-blue' href="/changement-de-representant">ici</a>.</div>
        <div>- Si le représentant légal est en cours de modification, merci d’adresser à <MailTo /> un PV d’AG signé par le représentant légal actuel et le nouveau représentant légal, pour confirmer que le changement est en cours.</div>
        <div>- Pour toute autre situation, merci d’adresser un email à <MailTo />.</div>
      </div>
    </div>
  )
}

const WrongDenominationBlock = ({ currentUser }: BlockProps) => {
  const { social_denomination, inpiData } = currentUser
  return (
    <div className="mb-4">
      <div className="">
        Le nom de la société (“{social_denomination}”) que vous avez déclaré est différent du nom présent sur l’INPI (“{inpiData.social_denomination}”)
      </div>
      <div>- Si le nom de société a déjà été changé, merci de nous adresser par email votre nouveau Kbis à <MailTo />.</div>
      <div className="">- Si le nom de société est en cours de changement, merci d’adresser à <MailTo /> un PV d’AG signé par le représentant légal pour confirmer que le changement est en cours.</div>
      <div className="">- Pour toute autre situation, merci d’adresser un email à <MailTo />.</div>
    </div>
  )
}

const WrongJuridicFormBlock = ({ currentUser }: BlockProps) => {
  const { juridic_form, forme_juridique_pappers } = currentUser
  return (
    <div className="mb-4">
      <div className="">
        La forme juridique déclarée sur notre site ({juridic_form}) est différente de celle de l’INPI ({forme_juridique_pappers}).<br />
        Merci d’adresser un email à <MailTo />.
      </div>
    </div>
  )
}

const ForbiddenJuridicFormBlock = ({ currentUser }: BlockProps) => {
  const { forme_juridique_pappers } = currentUser
  return (
    <div className="mb-4">
      <div className="">
        Votre forme juridique ({forme_juridique_pappers}) n’est pas acceptée en domiciliation commerciale.<br />
        Merci d’adresser un email à <MailTo />.
      </div>
    </div>
  )
}

const MissingInpiDataBlock = () => {
  return (
    <div className="mb-4">
      Aucune donnée n’est présente sur l’INPI, ce qui ne nous permet pas de réaliser les vérifications nécessaires.<br />
      Merci d’adresser un email à <MailTo />.
    </div>
  )
}

const WrongSirenScoreModal = ({ currentUser }: Props) => {
  const { siren, forme_juridique_pappers_matches, inpiData, hasForbiddenJuridicForm } = currentUser
  return (
    <div className="AmlModal">
      <div className="form-block">
        <div className="label-form">
          <span className="text-lg">Contrôle de cohérence de votre SIREN échoué</span>
        </div>
        <div className="mb-4">
          Nous avons détecté une ou plusieurs différences entre les informations que vous avez fournies et les informations disponibles sur le site de l’INPI
          (<a className='[&&]:text-blue' href={`https://data.inpi.fr/entreprises/${siren}`} target="_blank" rel="noreferrer">https://data.inpi.fr/entreprises/{siren}</a>) :
        </div>
        <div className="text-normal-gray">
          {hasBadRepresentantScore(currentUser) && <WrongRepresentantBlock currentUser={currentUser} />}
          {hasBadDenominationScore(currentUser) && <WrongDenominationBlock currentUser={currentUser} />}
          {forme_juridique_pappers_matches === false && <WrongJuridicFormBlock currentUser={currentUser} />}
          {hasForbiddenJuridicForm && <ForbiddenJuridicFormBlock currentUser={currentUser} />}
          {!inpiData && <MissingInpiDataBlock />}
        </div>
      </div>
    </div>
  )
}

const MapStateToProps = state => ({
  currentUser: state.user.currentUser,
})

export default connect(MapStateToProps)(WrongSirenScoreModal)
